//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import { PALETTE_COLOURS } from '@/store/types/getters';
import { COLOURS } from '@/store/types/namespaces';

export default {
  name: 'DpRingGauge',
  props: {
    strokeWidth: { type: Number, default: 15 },
    isPercent: { type: Boolean, default: false },
    value: { type: [Number, String], default: 0 },
    rawValue: { type: Number, default: 0 },
    minValue: { type: Number, default: null },
    maxValue: { type: Number, default: null },
    state: { type: String, default: null },
  },
  data() {
    return {
      radius: 100,
    };
  },
  computed: {
    ...mapGetters(COLOURS, [PALETTE_COLOURS]),
    centerColour() {
      return this[PALETTE_COLOURS].white;
    },
    backgroundColour() {
      return this[PALETTE_COLOURS].neutral[1];
    },
    foregroundColour() {
      const colours = this[PALETTE_COLOURS];
      if (!this.state) return colours.primary;
      return colours[this.state];
    },
    mainText() {
      const { value, rawValue, isPercent } = this;
      let text = value || rawValue;
      if (!value && isPercent) {
        text = `${text}%`;
      }
      return text;
    },
    fontSize() {
      if (!this.mainText) return 0;
      const { length } = `${this.mainText}`;
      const maxSize = 24;
      return maxSize - (length / 1.5);
    },
    normalisedRadius() {
      return this.radius - this.strokeWidth * 2;
    },
    diameter() {
      return this.radius * 2;
    },
    circumference() {
      return this.normalisedRadius * 2 * Math.PI;
    },
    percent() {
      if (!this.isPercent && (this.minValue === null || this.maxValue === null)) {
        return 1;
      }

      const min = this.isPercent ? 0 : this.minValue;
      const max = this.isPercent ? 100 : this.maxValue;

      const percent = (this.rawValue - min) / (max - min);
      return Math.max(Math.min(percent, 1), 0);
    },
    strokeDashOffset() {
      return this.circumference - (this.percent * this.circumference);
    },
  },
};
